export const UPDATE_RECOMMENDATION_PRODUCTS = 'UPDATE_RECOMMENDATION_PRODUCTS';
